// Main Chatbot Module Export
// This file serves as the main entry point for the chatbot module

// Version Information
import packageInfo from './package.json';

// Log version information on module load
const logStyles = 'color: #FF6B6B; font-weight: bold;';
console.log('%cTNGAI 🤖', logStyles, `v${packageInfo.version}`);

// Core Components
export { default as ChatbotWidget } from './components/compositions/BaseChatbotWidget/ChatbotWidget';
export { default as ChatbotWidgetCore } from './components/compositions/BaseChatbotWidget/ChatbotWidgetCore';
export { default as Chatbot } from './components/compositions/Chatbot/Chatbot';

// Atomic Components
export { default as AIRevisionLoading } from './components/atoms/AIRevisionLoading/AIRevisionLoading';
export { default as ChatBadge } from './components/atoms/ChatBadge/ChatBadge';
export { default as ChatButton } from './components/atoms/ChatButton/ChatButton';
export { default as ChatHeader } from './components/atoms/ChatHeader/ChatHeader';
export { default as ChatIconButton } from './components/atoms/ChatIconButton/ChatIconButton';
export { default as ChatInput } from './components/atoms/ChatInput/ChatInput';
export { default as ChatMessage } from './components/atoms/ChatMessage/ChatMessage';
export { default as ChatMessages } from './components/atoms/ChatMessages/ChatMessages';
export { default as ChatTriggerButton } from './components/atoms/ChatTriggerButton/ChatTriggerButton';
export { default as ConversationHistory } from './components/atoms/ConversationHistory/ConversationHistory';
export { default as ToolIndicator } from './components/atoms/ToolIndicator/ToolIndicator';

// Specialized Components
export { default as ChatD3Modal } from './components/atoms/ChatD3Modal/ChatD3Modal';
export { default as ChatD3VisualizationCard } from './components/atoms/ChatD3VisualizationCard/ChatD3VisualizationCard';
export { default as ChatMermaidCard } from './components/atoms/ChatMermaidCard/ChatMermaidCard';
export { default as ChatMermaidModal } from './components/atoms/ChatMermaidModal/ChatMermaidModal';

// Contexts
export { AnalyticsFiltersProvider, useAnalyticsFilters } from './contexts/AnalyticsFiltersContext';

// Hooks
export { ChatbotProvider, useChatbotContext, useRequiredChatbotContext } from './hooks/ChatbotContext';
export { default as useChatbotPracticeView } from './hooks/useChatbotPracticeView';
export { default as useChatConversation } from './hooks/useChatConversation';
export { useMockData } from './hooks/useMockData';
export { default as useQuizRevisionConversation } from './hooks/useQuizRevisionConversation';
export { useQuizRevisionConversations } from './hooks/useQuizRevisionConversations';
export { default as useRevisionRegenerate } from './hooks/useRevisionRegenerate';
export { useStreamingHandlers } from './hooks/useStreamingHandlers';

// Services
export { default as chatService, createChatService } from './services/chatService';
export { createPracticeService, default as practiceService } from './services/practiceService';
export { createQuizRevisionConversation, invalidateQuizRevisionConversations } from './services/quizRevisionService';

// Utils
export { invalidateQuizRevisionOnReassign } from './utils/invalidateQuizRevisionOnReassign';
export { default as MessageContentParser } from './utils/MessageContentParser';
export { default as BaseParser } from './utils/parsers/BaseParser';
export { interactiveParsers } from './utils/parsers/InteractiveParsers';
export { default as MermaidParser } from './utils/parsers/MermaidParser';
export { parseToolEvents as toolEventParser } from './utils/parsers/toolEventParser';

// Models
export { ModelNameEnum } from './models/ModelNameEnum';

// Views
export { default as ChatbotPracticeExercise } from './views/ChatbotPracticeView/ChatbotPracticeExercise';
export { default as ChatbotPracticeView } from './views/ChatbotPracticeView/ChatbotPracticeView';
export { default as TeacherAIAnalyticsPanelView } from './views/TeacherAIAnalyticsPanelView/TeacherAIAnalyticsPanelView';
export { default as TeacherAnalyticsView } from './views/TeacherAnalyticsView/TeacherAnalyticsView';
export { default as RadarView } from './views/RadarView/RadarView';
export { default as TeacherToolsView } from './views/TeacherToolsView/TeacherToolsView';

// Utilities for building streaming options
export { mockMessages } from './hooks/mockMessages';
export { buildStreamOptions as streamOptionsBuilder } from './hooks/streamOptionsBuilder';
